
import { i18nGlobal } from '@/i18n'
import { CodiceFiscalePiva } from './fiscalCodeClass'
import { isNullOrUndefinedLocal } from './utils'


export const requiredNumRule = [
  ( v: any ) => ( !!v && ( typeof v == 'number' || v >= 0 ) ) || i18nGlobal.t( 'error.insertValue' ),
]

export const requiredNumRuleZeroAllowed = [
  ( v: any ) => ( !isNullOrUndefinedLocal( v ) && ( typeof v == 'number' || v >= 0 ) ) || i18nGlobal.t( 'error.insertValue' ),
]

export const notRequiredNumRule = [ ( v: any ) => ( !!v && ( typeof v == 'number' || v >= 0 ) ) || true ]

export const notRequiredRule = [ ( v: any ) => ( !!v && v !== '' ) || true ]
export const requiredRule = [ ( v: any ) => ( !!v && v !== '' ) || i18nGlobal.t( 'error.insertValue' ) ]
export const ruleMinAmount = ( min: number ) => [
  ( v: number ) => v >= min || i18nGlobal.t( 'generic.minAmount', { minAmount: min } ),
]

export function requiredRuleFunc ( v: any ) {
  if ( isNullOrUndefinedLocal( v ) ) return i18nGlobal.t( 'error.insertValue' )
  else return true
}
export function requiredRuleFuncWithLength ( v: any, length: number ) {
  if ( isNullOrUndefinedLocal( v ) || v.length > length ) return i18nGlobal.t( 'error.insertValidValue' )
  else return true
}
const isBlank = ( v: unknown ) => v == null || String( v ).trim() === ''


export const fiscalCodeRuleNotMandatory = [
  ( v: unknown ) => {
    if ( isBlank( v ) ) return true
    const res = CodiceFiscalePiva.validateCF( v, false )
    return res === true ? true : String( res ?? i18nGlobal.t( 'error.insertValidCFValue' ) )
  },
]

export const vatNumberRuleNotMandatory = [
  ( v: unknown ) => {
    if ( isBlank( v ) ) return true
    const res = CodiceFiscalePiva.validatePIVA( v, false )
    return res === true ? true : String( res ?? i18nGlobal.t( 'error.insertValidPIVAValue' ) )
  },
]

export const minutesRule = [ ( v: any ) => ( v >= 0 && v < 60 ) || i18nGlobal.t( 'error.insertValueMinutes' ) ]
export const hoursRule = [ ( v: any ) => ( v >= 0 && v < 24 ) || i18nGlobal.t( 'error.insertValueHours' ) ]

export const mobileRule = [
  ( v: any ) =>
    !v ||
    /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/.test( v ) ||
    i18nGlobal.t( 'error.insertValidValue' ),
]

export const mobileRuleMandatoryNoPrefix = [
  ( v: any ) => /^[0-9]{7,13}$/.test( v ) || i18nGlobal.t( 'error.insertValidValue' ),
]

export const mobileRuleNotMandatoryNoPrefix = [
  ( v: any ) => !v || /^[0-9]{7,13}$/.test( v ) || i18nGlobal.t( 'error.insertValidValue' ),
]

export const emailRule = [
  ( v: any ) =>
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
      v,
    ) || i18nGlobal.t( 'error.emailNotValid' ),
]

export const emailRuleNotMandatory = [
  ( v: any ) =>
    !v ||
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
      v,
    ) ||
    i18nGlobal.t( 'error.emailNotValid' ),
]

export const passwordComplexRule = [
  ( v: any ) =>
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-.,"()'_:;§°]).{8,}$/.test( v ) ||
    i18nGlobal.t( 'error.passwordNotValid' ),
]

export function requredRuleFuncWithLength ( v: any, length: number ) {
  if ( isNullOrUndefinedLocal( v ) || v.length > length ) return i18nGlobal.t( 'error.insertValidValue' )
  else return true
}

export const passwordRule = [ ( v: string ) => ( !!v && v !== '' && v.length > 7 ) || i18nGlobal.t( 'error.passwordNotValid' ) ]

/*
export const passwordCreateRules = [
    (v: any) => !!v || 'Inserisci la password',
    (v: any) =>
        !!validator.isStrongPassword(v ? v : '', {
            minLength: 10,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 0,
        }) || ('Password non valida'),
];

*/

export function isNotEmptyRule ( s: string ) {
  if ( isNullOrUndefinedLocal( s ) ) return i18nGlobal.t( 'error.empty' )
  else return true
}
